module.exports = __webpack_public_path__ + "img/no-data.bc445bd5.png";